require('./odometer.min');
import Accordion from './accordion.min';

require('./owl/owl.carousel.min');

const autoplay = true;

$(document).ready(function testimonials() {
  var speed = 0.5;
  var stay = 2;
  var $post = $('.testi');
  var slides = $post.children().length;
  var step = -100;
  var x = step;
  var pause = (speed + stay) * 1000;
  var index = 0;
  var first = $('.testi-1');

  first.clone().appendTo(first.parent());

  function myslider() {
    index++;
    if (index >= slides + 1) {
      $post.css('transition', '0s ease');
      $post.css('transform', 'translateX(0)');
      x = step;
      index = 1;
    }
    setTimeout(function () {
      $post.css('transition', +speed + 's ease');
      $post.css('transform', 'translateX(' + x + '%)');
      x = x + step;
    }, 150);
  }

  var myTimer = setInterval(myslider, pause);

  document.addEventListener('touchstart', handleTouchStart, false);
  document.addEventListener('touchmove', handleTouchMove, false);

  var xDown = null;
  var yDown = null;

  function getTouches(evt) {
    return (
      evt.touches || // browser API
      evt.originalEvent.touches
    ); // jQuery
  }

  function handleTouchStart(evt) {
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
  }

  function handleTouchMove(evt) {
    if (!xDown || !yDown) {
      return;
    }

    var xUp = evt.touches[0].clientX;
    var yUp = evt.touches[0].clientY;

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      /*most significant*/
      if (xDiff > 0) {
        clearInterval(myTimer);
        myTimer = setInterval(myslider, pause);
        if (x == (slides + 1) * -100) {
          $post.css('transition', '0s ease');
          $post.css('transform', 'translateX(0)');
          x = -100;
        }
        setTimeout(function () {
          $('.testi').css('transition', +speed + 's ease');
          $post.css('transform', 'translateX(' + x + '%)');
          x = x - 100;
        }, 150);
      } else {
        clearInterval(myTimer);
        myTimer = setInterval(myslider, pause);
        if (x == -100) {
          x = slides * -100;
          $post.css('transition', '0s ease');
          $post.css('transform', 'translateX(' + x + '%)');
          x = slides * -100 - 100;
        }
        setTimeout(function () {
          x = x + 200;
          $('.testi').css('transition', +speed + 's ease');
          $post.css('transform', 'translateX(' + x + '%)');
          x = x - 100;
        }, 150);
      }
    } else {
      if (yDiff > 0) {
        /* up swipe */
      } else {
        /* down swipe */
      }
    }
    /* reset values */
    xDown = null;
    yDown = null;
  }

});

function runCarouselTop() {
  var owl = $('.owl-carousel-top');
  owl.owlCarousel({
    loop: true,
    margin: 10,
    autoplay,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    nav: false,
    dots: false,
    items: 3,
    center: false,
    responsive: {
      0: {
        items: 1,
        margin: 20,
        width: '100%',
        stagePadding: 85,
      },
      600: {
        items: 1,
        center: false,
      },
      1000: {
        items: 2,
        center: false,
      },
      1400: {
        items: 3,
        center: false,
        margin: 10,
        loop: false,
      },
    },
  });
}

function runCarouselBottom() {
  var owl = $('.owl-carousel-bottom');
  owl.owlCarousel({
    loop: true,
    margin: 10,
    autoplay,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    nav: false,
    dots: false,
    items: 3,
    center: false,
    width: 600,
    responsive: {
      0: {
        items: 4,
        center: true,
        margin: 2,
      },
      600: {
        items: 4,
        center: true,
        margin: 2,
      },
      1000: {
        items: 3,
        center: true,
        stagePadding: 85,
      },
      1400: {
        items: 4,
        center: true,
        stagePadding: 85,
      },
    },
  });
}

function runCarouselCaseStudies() {
  var owl2 = $('.owl-carousel-case-studies');
  owl2.owlCarousel({
    loop: true,
    margin: 30,
    autoplay,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    nav: false,
    dots: false,
    items: 3,
    responsive: {
      0: {
        items: 1,
        center: true,
        stagePadding: 75,
      },
      1400: {
        items: 3,
        center: true,
      },
    },
  });
}

function initTopLinks() {
  $('.events-gallery-item-link').click(function () {
    setTimeout(() => {
      const l = $(this).attr('href');
      if (l) {
        const e = $(l);
        if (!e.parent().hasClass('is-active')) {
          e.click();
        }
      }
    }, 600)
  });
}

function initModalLinks() {
  const el = $('#iframe-event-pdf-viewer');
  const wrapper = $('#event-pdf-viewer');
  const c = 'hidden';
  const dButton = wrapper.find('.download-btn');

  function closeModal() {
    wrapper.addClass(c);
  }

  $('.modal-close-button').click(function () {
    closeModal();
  });
  $('.pdf-modal-btn').off('click').click(function () {
    const l = $(this).attr('data-link');
    wrapper.removeClass(c);
    var window_width = $(window).width();
    if (window_width <= 800) {
      el.attr('src', `https://docs.google.com/viewer?url=${l}&embedded=true`);
    } else {
      el.attr('src', l);
    }
    dButton.attr('href', l)
  });

  wrapper.find('.modal-inner').click(function (e) {
    e.stopPropagation();
  });

  wrapper.click(function () {
    closeModal();
  });
}


function initApp() {
  new Accordion('.accordion-container');
  setTimeout(function () {
    runCarouselTop();
    runCarouselBottom();
    runCarouselCaseStudies();
    $('.ac-q.poppins').eq(0).click();
    initTopLinks();
    initModalLinks();
  }, 500)
  $('.owl-carousel-case-studies').mouseenter(function () {
    initModalLinks();
  })
}

$(function () {
  initApp();
});



// WEBPACK FOOTER //
// ./scripts/libraries/events.js